<form apply="theme">
  <div [id]="'chips-'+keySelect" class="chips chips-autocomplete margin-all-0"
    [ngClass]="{'chip-single': type === 'single'}">
    <input class="custom-class">
  </div>
</form>